import React from 'react';

const ProblemSection: React.FC = () => {
  return (
    <section className="section-lg bg-off-white">
      <div className="container mx-auto px-4 content-medium">

        {/* ── Pill overline ───────────────────────────────── */}
        <div className="reveal flex justify-center mb-10">
          <span className="reveal-child badge-pill">
            <span className="badge-pill-dot" />
            Le constat
          </span>
        </div>

        {/* ── Main statement ──────────────────────────────── */}
        <div className="reveal text-center mb-14">
          <h2
            className="reveal-child font-display text-foreground leading-[1.08]"
            style={{ fontSize: 'clamp(2rem, 5.5vw, 3.75rem)' }}
          >
            Tu as bâti une marque magnifique.
            <br className="hidden sm:block" />
            <span
              className="font-medium"
              style={{ fontStyle: 'italic', color: 'hsl(var(--rose-text))' }}
            >
              {' '}Il est temps d'en faire un business.
            </span>
          </h2>
        </div>

        {/* ── Body paragraphs ─────────────────────────────── */}
        <div className="reveal max-w-2xl mx-auto space-y-5 mb-14">
          <p className="reveal-child text-base text-muted-foreground leading-relaxed">
            Tu postes, tu crées, tu mets tout ton cœur dans ta communication… et pourtant, le soir, quand tu regardes tes chiffres, c'est le silence.
          </p>
          <p className="reveal-child text-base text-muted-foreground leading-relaxed">
            Tu as un beau logo, un feed Instagram soigné, peut-être même un site dont tu es fière.
          </p>
          <p className="reveal-child text-base text-muted-foreground leading-relaxed">
            Mais tu as l'impression d'être sur un tapis roulant : si tu arrêtes de poster, tout s'arrête.{' '}
            <strong className="text-foreground">Tu ne possèdes pas un système, c'est ton contenu qui te possède.</strong>
          </p>
          <p className="reveal-child text-base text-muted-foreground leading-relaxed">
            Le problème n'est pas ton talent. C'est qu'il te manque la structure qui transforme un visiteur anonyme en client fidèle, sans que tu aies besoin d'être derrière chaque écran.
          </p>
        </div>

        {/* ── Decorative separator ────────────────────────── */}
        <div className="decorative-dot my-10">
          <span />
        </div>

        {/* ── Pull-quote ──────────────────────────────────── */}
        <div className="reveal pull-quote max-w-xl mx-auto">
          <p
            className="reveal-child font-display font-semibold text-foreground leading-snug"
            style={{ fontSize: 'clamp(1.25rem, 3vw, 1.75rem)' }}
          >
            Tu as une marque. Mais tu n'as pas encore un{' '}
            <span
              className="font-medium"
              style={{ fontStyle: 'italic', color: 'hsl(var(--rose-text))' }}
            >
              business.
            </span>
          </p>
        </div>

      </div>
    </section>
  );
};

export default ProblemSection;
